import { Component, computed, input } from '@angular/core';

import { isNil } from '@core/utils/shared-utils';

import { PillsOverflowComponent } from '@shared/components/pills-overflow/pills-overflow.component';
import { stringsToPillItems } from '@shared/components/pills-overflow/pills-overflow.utils';
import { CellOverlayAction } from '@shared/components/table/table-cell/actions-overlay/actions-overlay.component';
import { CellWithOverlayActions } from '@shared/components/table/table-cell/table-cell.component';
import {
  formatCellValue,
  processEnumValue
} from '@shared/components/table/table-cell/utils';

@Component({
  selector: 'app-enum-cell',
  imports: [PillsOverflowComponent],
  templateUrl: './enum-cell.component.html'
})
export class EnumCellComponent implements CellWithOverlayActions {
  availableCellActions: CellOverlayAction[] = ['copy'];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) => formatCellValue(v, 'enum');

  value = input<unknown | undefined>(undefined);

  protected pillItems = computed(() => {
    const values = this.processedValue();
    return !isNil(values) ? stringsToPillItems(values) : [];
  });

  protected processedValue = computed<string[] | undefined>(() =>
    processEnumValue(this.value())
  );
}
